import { ICONS } from '@frontend/icons';
import React from 'react';

import { useDurationInputSelect } from './duration-input-select.controller';

export interface DurationInputSelectProps {
    className?: string;
    value?: string;
    selectItems: string[];
    onChange?: (value: string | undefined) => void;
}

export const DurationInputSelect = (props: DurationInputSelectProps) => {
    const viewProps = useDurationInputSelect(props);
    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
            }}
            data-show-action-button='false'
            data-show-placeholder='true'
            data-size='Small'
            data-state='Open'
            data-type='Select'
            className='flex flex-col items-start justify-start gap-1 self-stretch'>
            <div className='bg-background-surface outline-border-default inline-flex h-10 w-full cursor-pointer items-center overflow-hidden rounded-md px-4 outline outline-1 outline-offset-[-1px]'>
                <div
                    className='flex h-full w-full items-center gap-2.5'
                    onClick={() => {
                        viewProps.changeShow(!viewProps.show);
                    }}>
                    <button className='text-foreground-default justify-start text-sm font-medium'>{viewProps.value ? viewProps.value : 'Select...'}</button>
                </div>
                <div className='flex items-center justify-start gap-2'>
                    {viewProps.value !== undefined && (
                        <ICONS.BUTTON.CLOSE
                            className='text-brand-muted hover:text-foreground-default hover:cursor-pointer'
                            onClick={viewProps.clear}
                        />
                    )}
                    {viewProps.show ? (
                        <ICONS.BUTTON.CHEVRON_UP
                            className={`text-brand-muted hover:text-foreground-default hover:cursor-pointer`}
                            id='group-select-category'
                            onClick={() => {
                                viewProps.changeShow(!viewProps.show);
                            }}
                        />
                    ) : (
                        <ICONS.BUTTON.CHEVRON_DOWN
                            className={`text-brand-muted hover:text-foreground-default hover:cursor-pointer`}
                            id='group-select-category'
                            onClick={() => {
                                viewProps.changeShow(!viewProps.show);
                            }}
                        />
                    )}
                </div>
            </div>
            {viewProps.show && (
                <div className='dropdown-content bg-background-surface outline-border-default flex flex-col items-start justify-start gap-4 self-stretch overflow-hidden rounded-md outline outline-1 outline-offset-[-1px]'>
                    <div className='flex flex-col items-start justify-start gap-4 self-stretch p-2'>
                        <div className='flex flex-col items-start justify-start self-stretch'>
                            {props.selectItems.map((value) => {
                                return (
                                    <div
                                        key={value}
                                        className='dropdown-item hover:bg-background-default inline-flex cursor-pointer items-center justify-start gap-2.5 self-stretch rounded-md p-2'
                                        onClick={() => viewProps.onChange(value)}>
                                        <div className='text-foreground-default justify-start text-sm font-medium'>{value}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
